import React from "react";
import {NavDropdown} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {ChangeUserCompany} from "../../redux/actions/Auth.Action";

function ChangeCompany() {
  const accessCompany = useSelector(
    (state) => state.Auth.userData.companies || []
  );
  const company = useSelector((state) => state.Auth.company);
  const currentCompany =
    accessCompany.find((cmp) => cmp.id === company.id) || [];
  const dispatch = useDispatch();
  return (
    <NavDropdown
      className="topbar-center"
      title={<h4 className="logo">{currentCompany.name}</h4>}
    >
      <span className="dropdown-item d-flex align-items-center">
        <img
          src={currentCompany.logo}
          className="avatar pl-1"
          alt={currentCompany.name}
        />
        {currentCompany.name}
      </span>
      <div className="dropdown-divider" />
      {accessCompany.map((cmp, index) => {
        if (cmp.id !== currentCompany.id) {
          return (
            <span
              onClick={() => dispatch(ChangeUserCompany(cmp.id))}
              className="dropdown-item d-flex align-items-center overflow-hidden"
              key={index}
            >
              <img src={cmp.logo} className="avatar pl-1" alt={cmp.name} />
              {cmp.name}
            </span>
          );
        }
      })}
    </NavDropdown>
  );
}
export default React.memo(ChangeCompany);
